import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { AdSlot } from '@search/ads';
import { useLoaded } from '../../hooks/useLoaded';
import { useMobile } from '../../hooks/useMobile';
export const MastheadTestId = 'serp-masthead-testid';
export const Masthead = () => {
    const { isMobile } = useMobile();
    const isLoaded = useLoaded();
    return (_jsx(Box, { textAlign: "center", display: { 'breakpoint.base': 'none', 'breakpoint.md': 'block' }, height: { 'breakpoint.base': 'auto', 'breakpoint.md': '250px' }, testId: MastheadTestId, children: isLoaded && !isMobile && _jsx(AdSlot, { slot: "mastHead" }) }));
};
